import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { useState } from "react";
import slide1 from "../../../assets/images/slide1.webp";
import slide2 from "../../../assets/images/slide2.webp";
import slide3 from "../../../assets/images/slide3.webp";
export default function Swipe() {
  const [activeIndex, setActiveIndex] = useState(0);

  // Handle slide change event to update the active index
  const onSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex);
  };

  const totalSlides = 8; // Total number of slides
  const progress = (activeIndex / (totalSlides - 2)) * 40; // Calculate progress percentage

  return (
    <div className="relative">
      <Swiper
        spaceBetween={50}
        slidesPerView={4}
        onSlideChange={onSlideChange} // Update activeIndex on slide change
        onSwiper={(swiper) => console.log(swiper)}
      >
        <SwiperSlide>
          <img src={slide1} alt="" className="rounded" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={slide2} alt="" className="rounded" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={slide3} alt="" className="rounded" />
        </SwiperSlide>
        <SwiperSlide>
          {" "}
          <img src={slide1} alt="" className="rounded" />
        </SwiperSlide>
        <SwiperSlide>
          {" "}
          <img src={slide2} alt="" className="rounded" />
        </SwiperSlide>
        <SwiperSlide>
          {" "}
          <img src={slide3} alt="" className="rounded" />
        </SwiperSlide>
        <SwiperSlide>
          {" "}
          <img src={slide1} alt="" className="rounded" />
        </SwiperSlide>
        <SwiperSlide>
          {" "}
          <img src={slide2} alt="" className="rounded" />
        </SwiperSlide>
      </Swiper>

      {/* Progress Bar */}
      <div className="absolute bottom-[-30px] left-0 w-full bg-gray-300 h-2">
        <div
          style={{ width: `${progress}%` }}
          className="bg-[#919191] h-full transition-all duration-300"
        />
      </div>
    </div>
  );
}
